import type { FC, PropsWithChildren } from "react";
import { FloatingArrow } from "@floating-ui/react";
import { useTooltip } from "./useTooltip";
import { TooltipContainer as Container } from "./Tooltip.styles";
import type { TooltipProps } from "./Tooltip.d";
export const Tooltip: FC<PropsWithChildren<TooltipProps>> = ({
  children,
  text,
  ...props
}) => {
  const {
    open,
    x,
    y,
    strategy,
    refs,
    getFloatingProps,
    getReferenceProps,
    context,
    arrowRef
  } = useTooltip(props);
  return <>
			<span ref={refs.setReference} {...getReferenceProps()}>
				{children}
			</span>
			{open && <Container ref={refs.setFloating} $position={strategy} $top={y} $left={x} {...getFloatingProps()}>
					{text instanceof Function ? text() : text}
					<FloatingArrow ref={arrowRef} context={context} />
				</Container>}
		</>;
};